"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "grid grid-cols-10 divide-x divide-solid divide-beige-400 border-b border-beige-400" };
const _hoisted_2 = { class: "col-span-5 p-[10px] flex justify-start items-start" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "uppercase font-black text-xl leading-squished tracking-tight pl-5 pt-2" };
const _hoisted_5 = { class: "col-span-2 p-[10px] flex justify-center items-center font-semibold tracking-wider" };
const _hoisted_6 = { class: "col-span-1 text-center grid grid-cols-2 no-divider-x" };
const _hoisted_7 = { class: "relative grid grid-cols-1" };
const _hoisted_8 = ["disabled", "max"];
const _hoisted_9 = { class: "col-span-2 p-[10px] flex justify-center items-center font-semibold tracking-wider" };
const Alerts_1 = require("../../stores/Alerts");
const Basket_1 = require("../../stores/Basket");
const AlertType_1 = require("../../src/types/AlertType");
const debounce_1 = __importDefault(require("lodash/debounce"));
const SvgSprite_vue_1 = __importDefault(require("../SvgSprite.vue"));
const vue_3 = require("vue");
const Money_1 = require("../../src/Money");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BasketListItem',
    props: {
        product: null
    },
    setup(__props) {
        const props = __props;
        const store = (0, Basket_1.useBasketStore)();
        const alertStore = (0, Alerts_1.useAlertsStore)();
        const updating = (0, vue_3.ref)(false);
        function removeFromBasket(product, type) {
            store
                .remove(product, type)
                .then(() => {
                alertStore.add({
                    type: AlertType_1.AlertType.Success,
                    message: 'Item was removed from your basket',
                    key: 'basket-item',
                    url: '/basket',
                });
            })
                .catch((err) => {
                var _a, _b;
                let message = 'There was a problem removing the item from your basket.';
                if ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                    message = err.response.data.error;
                }
                alertStore.add({
                    type: AlertType_1.AlertType.Error,
                    message: message,
                    key: 'basket-item',
                });
            });
        }
        const updateProduct = (0, debounce_1.default)(function (event, product) {
            updating.value = true;
            store
                .update(product.id, product.type, event.target.value)
                .then((response) => {
                var _a, _b, _c, _d;
                alertStore.add({
                    type: (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message_type) !== null && _b !== void 0 ? _b : AlertType_1.AlertType.Success,
                    message: (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : 'Item quantity was updated!',
                    key: 'basket-item',
                    url: '/basket',
                });
            })
                .catch((err) => {
                var _a, _b;
                let message = 'There was a problem updating the item in your basket.';
                if ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                    message = err.response.data.error;
                }
                alertStore.add({
                    type: AlertType_1.AlertType.Error,
                    message: message,
                    key: 'basket-item',
                });
            })
                .then(() => {
                updating.value = false;
            });
        }, 500);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (__props.product.image)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                            key: 0,
                            src: __props.product.image.urls.size_1_1_60,
                            alt: "",
                            class: "w-[60px] h-[60px]"
                        }, null, 8, _hoisted_3))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(__props.product.name), 1)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(Money_1.formatMoney)(__props.product.price)), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            type: "number",
                            onInput: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(updateProduct)($event, __props.product))),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.product.quantity) = $event)),
                            disabled: updating.value,
                            min: "1",
                            max: __props.product.max_quantity,
                            class: "p-2 h-[60px]"
                        }, null, 40, _hoisted_8), [
                            [vue_2.vModelText, __props.product.quantity]
                        ]),
                        (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                            href: "icon-pencil",
                            class: "h-[10px] w-[10px] absolute right-[10px] top-[10px]"
                        })
                    ]),
                    (0, vue_2.createElementVNode)("button", {
                        onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (removeFromBasket(__props.product.id, __props.product.type)), ["prevent"])),
                        type: "button",
                        class: "flex justify-center items-center h-[60px]"
                    }, [
                        (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                            href: "icon-delete",
                            class: "w-4 h-5"
                        })
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(Money_1.formatMoney)(__props.product.total)), 1)
            ]));
        };
    }
});
